import { render, staticRenderFns } from "./PassportTemplatesList.vue?vue&type=template&id=3c21aab2&"
import script from "./PassportTemplatesList.vue?vue&type=script&lang=js&"
export * from "./PassportTemplatesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports